export default __webpack_public_path__ + "static/media/phone-handset.73b901ac.svg";